export const DEFAULT_PAGE = 0;
export const DEFAULT_PER_PAGE = 100;
export const PER_PAGE_OPTIONS = [100, 250, 500, 1000];
export const PARSE_INT_RADIX = 10; 